<template lang="pug">
  .view-users
    ui-navbar-panel(title="Пользователи")
      router-link(:to="{ name: 'newUser' }")
        b-button(type="is-primary" icon-left="plus-circle") Новый пользователь

    b-tabs()
      b-tab-item(v-for="role in roles.items" :key="role.id" :label="role.title_plural")
        b-table(:data="role.users.items", @click="routeToUser", hoverable)
          template(v-for="(column, field) in columns")
            b-table-column.control(
              :field="field"
              v-bind="column"
              v-slot="{row}"
            )
              component(v-if="column.component" :is="column.component") {{ getProperty(row, field) }}
              template(v-else-if="field==='status'")
                b-tooltip(:label="row.status_label")
                  b-icon(:icon="row.statusLabel.icon", :type="row.statusLabel.color")
              template(v-else-if="field==='created_at'")
                | {{ row.created_at | dateFormat }}
              template(v-else-if="field==='action'")
                router-link(:to="{ name: 'editUser', params: { id: row.id } }")
                  b-icon(icon="pencil-outline", size="is-small")
              template(v-else)
                | {{ getProperty(row, field) }}
</template>

<script>
import Role from '@/models/Role';
import { getProperty } from '@/helpers/object';

const visible = true;
const sortable = true;
const numeric = true;

export default {
  name: 'view-users',
  props: {},

  data: () => ({
    roles: Role.collection(),
    isModalActive: false,
    columns: {
      id: { label: 'ID', visible, sortable, numeric },
      status: { label: 'Статус', visible, sortable},
      fullName: { label: 'ФИО', visible, sortable },
      email: { label: 'Email', visible, sortable },
      'platform.name': { label: 'Платформа', visible, sortable },
      created_at: { label: 'Создан', visible, sortable },
      action: {label: '', visible},
    },
  }),

  created() {
    this.roles.$fetch({ include: 'users.platform' });
  },

  methods: {
    getProperty,
    routeToUser({ id }) {
      this.$router.push({ name: 'editUser', params: { id } });
    },
  },
};
</script>
